import { PenTool } from 'lucide-react'
import { SignaturePad } from 'components/TreatmentPlan/Review'
import { Button } from 'components/Button'
import { useState } from 'react'
import { connect } from 'react-redux';
import { TreatmentPlansActions } from 'store/actions';
import toast from 'react-hot-toast';

let enhancer = connect(null, { ...TreatmentPlansActions });

const SignatureStep = ({ onNext, treatmentPlanId, drawSignatureOnTxpPdf }) => {
  const [signature, setSignature] = useState(null)
  const [loading, setLoading] = useState(false)

  const handleNext = async () => {
    setLoading(true);
    try {
      let formD = new FormData()
      formD.append('treatment_plan[signature]', signature)
      await drawSignatureOnTxpPdf(treatmentPlanId, formD);

      onNext()
    }
    catch (error) {
      toast.error(error.errors || 'Failed to save signature');
    }
    setLoading(false);
  }

  return (
    <div className="w-full space-y-8 py-4">
      <div className="w-full lg:max-w-[60%] mx-auto">
        <SignaturePad onSignature={setSignature} />
      </div>

      <div className="flex justify-center mt-6">
        <Button
          title="Sign & Continue to Payment"
          variant="tertiary"
          icon={<PenTool size={16} />}
          onClick={handleNext}
          loading={loading}
          disabled={!signature}
        />
      </div>
    </div>
  )
}

export default enhancer(SignatureStep)
